import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/altelvisual.png'


const _hoisted_1 = { class: "altel-banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "altel-banner__inner" }
const _hoisted_4 = { class: "altel-banner__left altel-banner__item" }
const _hoisted_5 = { class: "altel-banner__text" }
const _hoisted_6 = { class: "altel-banner__title" }
const _hoisted_7 = { class: "altel-banner__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('banner.title')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('banner.subtitle')), 1)
          ])
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "altel-banner__right altel-banner__item" }, [
          _createElementVNode("img", {
            class: "altel-banner__img",
            src: _imports_0,
            alt: "banner"
          })
        ], -1))
      ])
    ])
  ]))
}